export function calculateHeight(
  format: 'desktop' | 'mobile',
  showNextButton?: boolean,
  userHasInsurances?: boolean,
) {
  const baseHeight = format === 'mobile' ? '100vh' : '90dvh';
  const height = `calc(${baseHeight} - 64px - 51px )`; // - 'Total a pagar' height

  if (showNextButton) return `calc(${height} - 80px)`; // - footer next button height
  if (!userHasInsurances) `calc(${height} - 42px)`; // - insurance message height

  return height;
}
